export const NAVIGATION_OPEN = 'NAVIGATION_OPEN';
export const BAROMETER_SUBMIT = 'Barometer submitted';
export const SEND_TOKEN = 'Send token to Server';
export const SAVE_TOKEN = 'Save token';
export const STORE_NAVIGATION = 'store navigation';
export const STORE_NEWS = 'Store News Items';
export const STORE_NEWS_CATEGORIES = 'Store News Categories';
export const STORE_EVENTS = 'Store Calender events';
export const NEWS_SET_LIKES = 'News - set Likes';
export const STORE_IMPRESSIONS = 'Store Impressions';
export const IMPRESSION_SET_LIKES = 'Impressions - set Likes';
export const ARTICLE_UPDATE = 'Update Article';
export const STORE_BULLETIN = 'Store - Bulletin Items';
export const ADD_ARTICLE = 'Add - Bulletin Item';
export const STORE_BULLETIN_CATEGORIES = 'Store - Bulletin Categories';



// WEBPACK FOOTER //
// ./src/utils/store/actions/general.js